import React from "react";
import { Trans } from "react-i18next";
import styled from "styled-components/macro";
import { useViewerQuery, useViewerXps } from "../../../../../queries/viewerQuery";
import { useNavigate } from "react-router-dom";
import { SUBSCRIPTION } from "../../../../../root/profile/ProfileRouter.config";
import Flames from "../../../../../components/fire/Flames";
import { strengthFn } from "../../../../../components/fire/FireStats";
import { STREAK_FREEZE_XPS, STREAK_FREEZE_XPS_OUTAGE } from "../../../../../sharedJs__generated/constants";
import { QuestMessage } from "../misc/QuestMessage";
import { useSetLastImpulse } from "hooks/useSetLastImpulse";
import TransVariable from "components/other/TransVariable";
import { isOutageApplicable } from "sharedJs__generated/functions";
import { addDays } from "date-fns";
const SFlames = styled(Flames)`
  display: inline-block;
  margin: 0 10px -7px 10px;
  transform: scale(1.1);
`;

const BubbleContent = styled.div`
  cursor: pointer;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  justify-content: center;
`;

export const StreakRecoveryBubble: React.FC = () => {
  const { isSubscriber, viewer } = useViewerQuery();
  const navigate = useNavigate();
  const setLastImpulse = useSetLastImpulse();
  const { xps } = useViewerXps();
  const streakLength = xps?.yesterdayLostStreak || 0;
  const streakFreezeXps = isOutageApplicable(addDays(new Date(), -(viewer?.createdBeforeDays || 0)))
    ? STREAK_FREEZE_XPS_OUTAGE
    : STREAK_FREEZE_XPS;
  const handleClick = () => {
    if (!isSubscriber) {
      setLastImpulse("streakRecovery");
      navigate(SUBSCRIPTION.url());
    }
  };

  return (
    <QuestMessage>
      <BubbleContent onClick={handleClick}>
        <TextWrapper>
          <div>
            <Trans>
              Oh no! You lost your <TransVariable text={streakLength.toString()} />
              -day streak.
            </Trans>
          </div>
          <div>
            <Trans>
              Collect
              <SFlames
                strength={strengthFn(Math.max(streakFreezeXps - (viewer?.streakFreezeXps ?? 0), 1))}
                xps={Math.max(streakFreezeXps - (viewer?.streakFreezeXps ?? 0), 1)}
                noZZ
              />
              more today to recover your streak!
            </Trans>
          </div>

          {!isSubscriber && (
            <div>
              <Trans>Or subscribe to premium now to restore your daily streak immediately!</Trans>
            </div>
          )}
        </TextWrapper>
      </BubbleContent>
    </QuestMessage>
  );
};
